import { Components, Theme } from '@mui/material';

export const MuiTableRow: Components<Omit<Theme, 'components'>>['MuiTableRow'] =
  {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: '8px 16px',
        borderBottomColor: theme.palette.surface.outlineVariant,

        div: {
          display: 'inline-flex',
          alignItems: 'center',
          columnGap: '8px',
        },

        '&:last-of-type': { borderBottom: 'none' },
      }),
    },
  };
